import PDFDocument, { registerStdFonts } from 'pdfkit';
import courier from 'pdfkit/standard-fonts/Courier';
import courierBold from 'pdfkit/standard-fonts/CourierBold';
import courierBoldOblique from 'pdfkit/standard-fonts/CourierBoldOblique';
import courierOblique from 'pdfkit/standard-fonts/CourierOblique';
import helvetica from 'pdfkit/standard-fonts/Helvetica';
import helveticaBold from 'pdfkit/standard-fonts/HelveticaBold';
import helveticaBoldOblique from 'pdfkit/standard-fonts/HelveticaBoldOblique';
import helveticaOblique from 'pdfkit/standard-fonts/HelveticaOblique';
import symbol from 'pdfkit/standard-fonts/Symbol';
import timesBold from 'pdfkit/standard-fonts/TimesBold';
import timesBoldItalic from 'pdfkit/standard-fonts/TimesBoldItalic';
import timesItalic from 'pdfkit/standard-fonts/TimesItalic';
import timesRoman from 'pdfkit/standard-fonts/TimesRoman';
import zapfDingbats from 'pdfkit/standard-fonts/ZapfDingbats';

/*
 * Since pdfkit 0.20, browser builds have to register the metrics of the standard fonts they use. A PDFDocument opens
 * Helvetica and svg-to-pdfkit maps the text of an SVG to the Helvetica, Times and Courier families, so all 14 standard
 * fonts are registered, as all of them were built in before.
 */
registerStdFonts(
  courier,
  courierBold,
  courierBoldOblique,
  courierOblique,
  helvetica,
  helveticaBold,
  helveticaBoldOblique,
  helveticaOblique,
  symbol,
  timesBold,
  timesBoldItalic,
  timesItalic,
  timesRoman,
  zapfDingbats
);

export default PDFDocument;
